import React from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const DetailPanelContent = ({ row, onClose }) => {
  const getRecordedIcon = (participant) => {
    if (participant.recordedContactId != null) {
      return <CheckCircleOutlineIcon color="success" />;
    } else if (participant.thirdPartyContactId != null) {
      return <HighlightOffIcon color="error" />;
    } else {
      return <HelpOutlineIcon color="disabled" />;
    }
  };

  const cellStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    textAlign: "left"
  };

  const centerCellStyle = {
    ...cellStyle,
    textAlign: "center"
  };

  return (
    <Box sx={{ p: 2, position: "relative" }}>
      <IconButton
        onClick={onClose}
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <h4>Participants ({row.participants.length})</h4>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={centerCellStyle}>Recorded</th>
            <th style={cellStyle}>Role</th>
            <th style={cellStyle}>Name</th>
            <th style={cellStyle}>Endpoint</th>
            <th style={cellStyle}>Competence</th>
            <th style={cellStyle}>Status</th>
            <th style={cellStyle}>Organisation</th>
            <th style={cellStyle}>Area</th>
            <th style={cellStyle}>Function</th>
            <th style={cellStyle}>Route</th>
          </tr>
        </thead>
        <tbody>
          {row.participants.map((participant) => (
            <tr key={participant.id}>
              <td style={centerCellStyle}>{getRecordedIcon(participant)}</td>
              <td style={cellStyle}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {participant.role === "CALLER" ? (
                    <CallMadeIcon style={{ marginRight: 4 }} />
                  ) : participant.role === "RECEIVER" ? (
                    <CallReceivedIcon style={{ marginRight: 4 }} />
                  ) : null}
                  {participant.role}
                </div>
              </td>
              <td style={cellStyle}>
                {participant.recordedContactName ||
                  participant.thirdPartyContactName ||
                  "Unknown"}
              </td>
              <td style={cellStyle}>
                {participant.endpointChannel}: {participant.endpointIdentifier}
              </td>
              <td style={cellStyle}>{participant.competence || "N/A"}</td>
              <td style={cellStyle}>{participant.status || "N/A"}</td>
              <td style={cellStyle}>{participant.organisation || "N/A"}</td>
              <td style={cellStyle}>{participant.area || "N/A"}</td>
              <td style={cellStyle}>{participant.function || "N/A"}</td>
              <td style={cellStyle}>{participant.route || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default DetailPanelContent;
